import styled from 'styled-components';
import { Link as GatsbyLink } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

export const CardsContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1500px;
  height: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  padding: 50px 0 0;

  @media (min-width: 992px) and (max-width: 1199.98px) {
    .insights_cardcontainer {
      width: 19rem;
    }
  }
`;

export const Container = styled.div`
  height: 30rem;
  width: 100%;
  border: 1px solid #ebebeb;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 10px;
  margin-bottom: 20px;
  position: relative;

  @media (min-width: 36rem) {
    width: ${({ isSlider }) => (isSlider ? '100%' : '20.25rem')};
  }
  &.Blue {
    position: relative;
    &:after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: ${({ hasImage }) =>
        hasImage ? 'rgba(27, 123, 221, 0.3)' : '#d8d8d8'} !important;
      z-index: -1;
    }
  }
  &.Gray {
    position: relative;
    &:after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: ${({ hasImage }) => (hasImage ? 'rgba(0, 0, 0, 0.3)' : '#d8d8d8')} !important;
      z-index: -1;
    }
  }

  &:after {
    ${({ overlay, hasImage }) => {
      if (overlay) {
        return hasImage
          ? `
          content: '';
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.3);
          z-index: -1;
        `
          : `
          content: '';
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: #d8d8d8;
          z-index: -1;
        `;
      }
      return null;
    }}
  }

  .play-button {
    height: 5.875rem;
    width: 5.875rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    cursor: pointer;
  }
  .play_button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    &:after {
      content: '';
      display: inline-block;
      width: 93px;
      height: 94px;
      margin: 0 auto;
      background-image: url(/svg/sprites.svg#playic);
    }
  }
`;

export const TopHalf = styled.div`
  height: 15rem;
  width: 100%;
  padding-top: 3.125rem;
  padding-bottom: 1.15rem;
  background-color: #fff;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-between;
`;

export const BottomHalf = styled.div`
  height: 15rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  img {
    height: inherit;
    object-fit: cover;
    @media (max-width: 375px) {
      height: 100%;
      object-fit: cover;
    }
  }
`;

export const Type = styled.span`
  font-family: 'DINRegular';
  font-size: 0.625rem;
  text-transform: uppercase;
  letter-spacing: 1.8px;
  margin-bottom: 1.5rem;
  color: ${({ white }) => (white ? '#fff' : '#000')};
`;

export const Title = styled.span`
  font-family: 'LibreBaskervilleRegular';
  font-size: 20px;
  text-align: center;
  width: 70%;
  line-height: 1.75rem;
  color: ${({ white }) => (white ? '#fff' : '#000')};
  @media (max-width: 1199.98px) {
    font-size: 18px;
  }
  @media (max-width: 767.98px) {
    font-size: 16px;
  }
`;

export const VideoTitle = styled.span`
  font-family: 'DINRegular';
  font-size: 0.75rem;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  letter-spacing: 1.3px;
  color: #fff;
`;

export const Tags = styled.button`
  border: none;
  background-color: transparent;
  font-family: 'DINRegular';
  font-size: 0.75rem;
  text-transform: uppercase;
  text-decoration: none;
  color: ${({ white }) => (white ? '#fff' : '#000')};
  padding: 0 0.3rem;

  &.text-black {
    color: #000;
    &:hover {
      color: #000;
    }
  }

  &:hover {
    color: ${({ white }) => (white ? '#fff' : '#0072c6')};
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const VideoWrapper = styled.div`
  width: 80%;
  height: 100%;
  padding: 20rem 0 1.25rem;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-end;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10rem 0 1.25rem;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-between;
  &.text-black > * {
    color: #000;
  }
  .title_heading {
    font-size: 10px;
    color: #000;
    letter-spacing: 1.8px;
    text-transform: uppercase;
    margin-bottom: 1.5rem;
  }
  &.infographic_image {
    padding: 50px 25px 20px !important;
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
`;

export const Link = styled(GatsbyLink)`
  font-family: 'DINRegular';
  font-size: 0.75rem;
  text-transform: uppercase;
  text-decoration: underline;
  color: #fff;
`;

export const LazyImage = styled(LazyLoadImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const BgLazyImage = styled(LazyLoadImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -5;
`;

export const BottomButton = styled(GatsbyLink)`
  font-family: 'DINRegular';
  font-size: 0.75rem;
  text-transform: uppercase;
  background-color: #1b7bdd;
  color: #fff;
  height: 3.75rem;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  cursor: pointer;
  text-align: center;
  line-height: 3.75rem;
  text-decoration: none;

  &:hover {
    background-color: #0072c6;
  }
`;
export const ImageSection = styled.div`
  span {
    position: absolute;
    top: 0px;
    z-index: -1;
    left: 0px;
    right: 0px;
  }
`;
